import React, { Component, Suspense } from "react";
import { Divider } from "react-materialize";
import { withRouter } from "react-router";
import "./UserManagementSection.styles.scss";
import { connect } from "react-redux";
import { changeHierarchyTableTo } from "../../../../store/actions/hierarchyTableSelectAction.js";
import GeopgraphyTable from "../GeopgraphyTable/GeopgraphyTable";

// const UserTable = lazy(() => import("../UserTable/UserTable"));
// const GeopgraphyTable = lazy(
//   () => import("../GeopgraphyTable/GeopgraphyTable")
// );

class HierarchyManagementSection extends Component {
  componentDidMount() {
    // if (new URLSearchParams(window.location.search).get("tab")) {
    //   const tab = new URLSearchParams(window.location.search).get("tab");
    //   this.props.history.push({ search: `tab=${tab}` });
    //   this.props.changeTableTo(tab);
    // } else {
    //   this.props.history.push({ search: `tab=user` });
    // }
    // if (!params) params.append("tab", "geo");
    // this.props.history.push({ search: params.toString() });
    // this.props.history.push({ search: `tab=geo` });
    // this.props.changeTableTo("geo");
  }
  // onChangeTab = (tab) => {
  //   const params = new URLSearchParams();
  //   params.append("tab", tab);
  //   this.props.history.push({ search: params.toString() });
  //   this.props.changeTableTo(tab);
  // };
  render() {
    // const localUserType = JSON.parse(localStorage.getItem("currUserType"));
    //console.log(changeHierarchyTableTo);
    return (
      <div className="user-management" style={{ padding: 24 }}>
        <div className="title-buttons-container">
          <div className="title">
            {/* <h2>Hierarchy Management</h2> */}
            <h2>Geo Management</h2>
          </div>

          {/* <div className="buttons-group">
            {localUserType === "bkash-super-user" && (
              <Button
                className={`im-btn geo-btn ${
                  this.props.active_table === "geo" ? `active` : `inactive`
                }`}
                onClick={() => this.onChangeTab("geo")}
                node="button"
                style={{
                  marginRight: "0px",
                }}
                waves="light"
              >
                <Icon left>location_on</Icon>
                Geography
              </Button>
            )}
            <Button
              className={`im-btn mdo-btn ${
                this.props.active_table === "user" ? `active` : `inactive`
              }`}
              onClick={() => this.onChangeTab("user")}
              node="button"
              style={{
                marginRight: "0px",
              }}
              waves="light"
            >
              <Icon left>person</Icon>
              User
            </Button>
          </div> */}
        </div>

        <Divider />
        <Suspense fallback={<div>Loading....</div>}>
          {/* {this.props.active_table === "geo" && <GeopgraphyTable />} */}
          {/* {this.props.active_table === "user" && <UserTable />} */}
          <GeopgraphyTable />
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  active_table: state.selectedHierarchyTable.active_hierarchy_module,
});

const mapDispatchToProps = (dispatch) => ({
  changeTableTo: (tableCurrent) =>
    dispatch(changeHierarchyTableTo(tableCurrent)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HierarchyManagementSection)
);
